<!-- {{ token | async | json }} -->
<router-outlet></router-outlet>
<ngx-spinner *ngIf="shouldShowSpinner" bdColor="rgba(51, 51, 51, 0.8)" size="medium" color="#367fa9" type="ball-circus"></ngx-spinner>


 <!-- Modal Session time out -->
 <ng-template #logoutModel let-modal let-c="close">
    <div class="p-md-5 p-3">
      <header class="pb-md-3">
        <span class="text-uppercase smlgxt text-blue callbackbold">Session time out</span>
        <h2 class="popup-caption position-relative align-items-start">Do you want to stay?</h2>
      </header>
      <div class="box">
        <p class="m-0">{{idleState}}</p>
      </div>
      <footer class="boxfooter mt-3">
        <div>
          <button type="button" class="btnblue py-2 px-4 mb-3" name="btnStayComponent" (click)="modal.close('Stay click');stay()" >Stay</button>
        </div>
        <div>
          <button type="button"  class="btnline px-4 py-2" (click)="logout(null)" type="button">Logout</button>
        </div>
      </footer>
    </div>
    </ng-template>
